module.exports = __webpack_public_path__ + "assets/notification_error.2d906643.svg";